export default "__VITE_ASSET__Z8t5e1R7fQF1ey4k4_pxdw__"